import type { ScrollButtonProps } from './scroll-button.types';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/utils/helper';
import v1 from './scroll-button-v2.module.css';
import v2 from './scroll-button-v1.module.css';

export default function ScrollButton(props: ScrollButtonProps) {
  return (
    <button type='button' className={cn(v1.ScrollButton, v2.ScrollButton)} onClick={() => props.onClick()}>
      <span>{props.content}</span>
      <ChevronDown className={cn(v1.Icon, v2.Icon)} />
    </button>
  );
}
